var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsIn, IsInt, IsOptional, Matches, Max, MaxLength, Min, ValidateIf, } from 'class-validator';
import { LITERAL_PREFIX_MAX_LENGTH, PADDING_WIDTH_MAX, PADDING_WIDTH_MIN, START_VALUE_MAX, START_VALUE_MIN, } from '../../pvs-billing/identity/invoice-number-format.js';
const LITERAL_PREFIX_RE = /^[A-Za-z0-9 _-]{0,8}$/;
/**
 * Body for `PATCH /office-location-billing-details/:officeLocationId/numbering`.
 *
 * Every field is optional — the handler applies a partial update. All fields
 * are editable at any point in the office's lifecycle; the frontend uses the
 * `locks` booleans on the response DTO to gate confirm-modal/helper-text UX.
 */
export class UpdateInvoiceNumberingDto {
    invoiceLiteralPrefix;
    stornoLiteralPrefix;
    mahnungLiteralPrefix;
    yearFormat;
    paddingWidth;
    separator;
    invoiceStartValue;
    stornoStartValue;
    mahnungStartValue;
}
__decorate([
    IsOptional(),
    MaxLength(LITERAL_PREFIX_MAX_LENGTH),
    Matches(LITERAL_PREFIX_RE, {
        message: 'invoiceLiteralPrefix must be 0–8 chars of [A-Za-z0-9 _-]',
    }),
    __metadata("design:type", String)
], UpdateInvoiceNumberingDto.prototype, "invoiceLiteralPrefix", void 0);
__decorate([
    IsOptional(),
    MaxLength(LITERAL_PREFIX_MAX_LENGTH),
    Matches(LITERAL_PREFIX_RE, {
        message: 'stornoLiteralPrefix must be 0–8 chars of [A-Za-z0-9 _-]',
    }),
    __metadata("design:type", String)
], UpdateInvoiceNumberingDto.prototype, "stornoLiteralPrefix", void 0);
__decorate([
    IsOptional(),
    MaxLength(LITERAL_PREFIX_MAX_LENGTH),
    Matches(LITERAL_PREFIX_RE, {
        message: 'mahnungLiteralPrefix must be 0–8 chars of [A-Za-z0-9 _-]',
    }),
    __metadata("design:type", String)
], UpdateInvoiceNumberingDto.prototype, "mahnungLiteralPrefix", void 0);
__decorate([
    IsOptional(),
    IsEnum(['NONE', 'YY', 'YYYY']),
    __metadata("design:type", String)
], UpdateInvoiceNumberingDto.prototype, "yearFormat", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(PADDING_WIDTH_MIN),
    Max(PADDING_WIDTH_MAX),
    __metadata("design:type", Number)
], UpdateInvoiceNumberingDto.prototype, "paddingWidth", void 0);
__decorate([
    IsOptional(),
    IsIn(['', '-', '/', '.']),
    __metadata("design:type", String)
], UpdateInvoiceNumberingDto.prototype, "separator", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(START_VALUE_MIN),
    Max(START_VALUE_MAX),
    __metadata("design:type", Object)
], UpdateInvoiceNumberingDto.prototype, "invoiceStartValue", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(START_VALUE_MIN),
    Max(START_VALUE_MAX),
    __metadata("design:type", Object)
], UpdateInvoiceNumberingDto.prototype, "stornoStartValue", void 0);
__decorate([
    IsOptional(),
    ValidateIf((_, value) => value !== null),
    IsInt(),
    Min(START_VALUE_MIN),
    Max(START_VALUE_MAX),
    __metadata("design:type", Object)
], UpdateInvoiceNumberingDto.prototype, "mahnungStartValue", void 0);
//# sourceMappingURL=update-invoice-numbering.dto.js.map